import React from 'react';
import MilitaryTechRoundedIcon from '@mui/icons-material/MilitaryTechRounded';

const COLORS = ['#d49a16', '#7b8794', '#a66a3f'];

export default function PlaceBadge({ place }: { place: 1 | 2 | 3 }) {
   return <span title={`${place}${place === 1 ? 'st' : place === 2 ? 'nd' : 'rd'} place`} aria-label={`${place}${place === 1 ? 'st' : place === 2 ? 'nd' : 'rd'} place`} style={{ display: 'inline-flex', alignItems: 'center', gap: 3, color: COLORS[place - 1], fontWeight: 850 }}><MilitaryTechRoundedIcon sx={{ fontSize: 24 }} /><span>{place}</span></span>;
}
